import { useCallback, useSyncExternalStore } from 'react';
const THEME_KEY = 'rhd-theme';
const DARK_QUERY = '(prefers-color-scheme: dark)';
// Where the choice lives when localStorage throws (private mode): it then lasts for the tab.
let memoryTheme = null;
const themeListeners = new Set();
export function readTheme() {
    try {
        const t = localStorage.getItem(THEME_KEY);
        return t === 'dark' || t === 'light' ? t : memoryTheme;
    } catch  {
        return memoryTheme;
    }
}
function writeTheme(next) {
    memoryTheme = next;
    try {
        localStorage.setItem(THEME_KEY, next);
    } catch  {
    // private mode: the choice lasts for this tab only
    }
    for (const l of themeListeners)l();
}
function subscribeTheme(onChange) {
    themeListeners.add(onChange);
    // Another tab toggling the theme.
    window.addEventListener('storage', onChange);
    return ()=>{
        themeListeners.delete(onChange);
        window.removeEventListener('storage', onChange);
    };
}
function subscribeSystemDark(onChange) {
    const mq = window.matchMedia(DARK_QUERY);
    mq.addEventListener('change', onChange);
    return ()=>mq.removeEventListener('change', onChange);
}
const systemDarkNow = ()=>window.matchMedia(DARK_QUERY).matches;
// What a prerendered page was built with: no stored choice, light system. While hydrating
// React renders with these, so the markup matches, then re-renders with the browser's values.
const serverTheme = ()=>null;
const serverSystemDark = ()=>false;
/**
 * The 夜 / 昼 toggle shared by the marketing site and the app. `theme` is the explicit
 * choice (null = follow the system); `dark` is what is actually showing.
 */ export function useRhdTheme() {
    const theme = useSyncExternalStore(subscribeTheme, readTheme, serverTheme);
    const systemDark = useSyncExternalStore(subscribeSystemDark, systemDarkNow, serverSystemDark);
    const dark = theme ? theme === 'dark' : systemDark;
    const toggleTheme = useCallback(()=>writeTheme(dark ? 'light' : 'dark'), [
        dark
    ]);
    return {
        theme,
        dark,
        toggleTheme
    };
}
